import script from "./RecordsFilterBar.vue?vue&type=script&setup=true&lang=js"
export * from "./RecordsFilterBar.vue?vue&type=script&setup=true&lang=js"

import "./RecordsFilterBar.vue?vue&type=style&index=0&id=788f1ce3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-788f1ce3"]])

export default __exports__